import React from 'react';

import Skel from '../skel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import HomologationErrorIndicator from './homologation-error';

import * as fmt from '../../utils/fmt';

import styles from './styles.css';

/* eslint-disable complexity */

const LabelSubtitle = withStyles({
  root: {
    color: '#8B8B8D',
    textTransform: 'uppercase',
    fontSize: '12px',
  }
})(Typography);

export default function NewVehicleDetails({
  vehicle = {},
  history = {},
  homologationError = null,
  historyPrefix = 'cab',
  title = 'Veículo'
}) {
  const hist = col => {
    const field = `${historyPrefix}${col.charAt(0).toUpperCase()}${col.substring(1)}`;
    return history[field];
  };

  const loading = !(vehicle.id || hist('plate'));

  return <>
    <div className={styles.sectionTitleWrapper}>
      <Typography style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '0px' }}>
        {title}
      </Typography>
      <hr style={{ margin: 0, borderColor: '#8B8B8D', borderWidth: '1px' }} />
    </div>

    <Grid
      spacing={24}
      container
      style={{ fontSize: '14px', fontWeight: 'bold', padding: '0rem 5px' }}
    >
      <Grid item sm={6}>
        <div className={styles.gridCell}>
          <LabelSubtitle variant="subtitle2">
            Placa
          </LabelSubtitle>
          <Skel loading={loading}>{vehicle.plate || hist('plate')}</Skel>
        </div>
      </Grid>

      <HomologationErrorIndicator loading={loading} error={homologationError} />

      <Grid item sm={6}>
        <div className={styles.gridCell}>
          <LabelSubtitle variant="subtitle2">
            Marca
          </LabelSubtitle>
          <Skel loading={loading}>
            {vehicle.brand && vehicle.brand.description || hist('brand')}
          </Skel>
        </div>
      </Grid>

      <Grid item sm={6}>
        <div className={styles.gridCell}>
          <LabelSubtitle variant="subtitle2">
            Modelo
          </LabelSubtitle>
          <Skel loading={loading}>
            {vehicle.model ? vehicle.model.description : hist('model')}
          </Skel>
        </div>
      </Grid>

      {vehicle.type && (
        <Grid item sm={6}>
          <div className={styles.gridCell}>
            <LabelSubtitle variant="subtitle2">
              Tipo
            </LabelSubtitle>
            <Skel loading={loading}>
              {vehicle.type.description}
            </Skel>
          </div>
        </Grid>
      )}

      {vehicle.bodywork && (
        <Grid item sm={6}>
          <div className={styles.gridCell}>
            <LabelSubtitle variant="subtitle2">
              Carroceria
            </LabelSubtitle>
            <Skel loading={loading}>
              {vehicle.bodywork ? vehicle.bodywork.description : hist('bodywork')}
            </Skel>
          </div>
        </Grid>
      )}

      <Grid item sm={6}>
        <div className={styles.gridCell}>
          <LabelSubtitle variant="subtitle2">
            Ano Fabricação/Modelo
          </LabelSubtitle>
          <Skel loading={loading}>
            {vehicle.fabricationYear || hist('fabricationYear')}
            /
            {vehicle.modelYear || hist('modelYear')}
          </Skel>
        </div>
      </Grid>

      <Grid item sm={6}>
        <div className={styles.gridCell}>
          <LabelSubtitle variant="subtitle2">
            Placa (Registro)
          </LabelSubtitle>
          <Skel loading={loading}>
            {
              [
                vehicle.plateCity && vehicle.plateCity.name,
                vehicle.plateState ? vehicle.plateState.name : hist('UF')
              ].filter(x => x && !!x.trim().length).join(' - ')
            }
          </Skel>
        </div>
      </Grid>

      <Grid item sm={6}>
        <div className={styles.gridCell}>
          <LabelSubtitle variant="subtitle2">
            Renavam
          </LabelSubtitle>
          <Skel loading={loading}>{vehicle.renavam || hist('renavam')}</Skel>
        </div>
      </Grid>

      <Grid item sm={6}>
        <div className={styles.gridCell}>
          <LabelSubtitle variant="subtitle2">
            Chassi
          </LabelSubtitle>
          <Skel loading={loading}>{vehicle.chassis || hist('chassis')}</Skel>
        </div>
      </Grid>

      <Grid item sm={6}>
        <div className={styles.gridCell}>
          <LabelSubtitle variant="subtitle2">
            ANTT
          </LabelSubtitle>
          <Skel loading={loading}>{vehicle.antt || hist('antt') || '--'}</Skel>
        </div>
      </Grid>

      <Grid item sm={6}>
        <div className={styles.gridCell}>
          <LabelSubtitle variant="subtitle2">
            Último Licenciamento
          </LabelSubtitle>
          <Skel loading={loading}>
            {fmt.isoDate(vehicle.lastLicensing || hist('lastLicensing')) || '--'}
          </Skel>
        </div>
      </Grid>

      {vehicle.owner && (
        <Grid item md={12}>
          <div className={styles.gridCell}>
            <LabelSubtitle variant="subtitle2">
              Proprietário do {title}
            </LabelSubtitle>
            <Skel loading={loading}>
              {vehicle.owner ? vehicle.owner.name : hist('ownerName')}
            </Skel>
          </div>
        </Grid>
      )}
    </Grid>
  </>;
}
